import { render, staticRenderFns } from "./index--form.vue?vue&type=template&id=33043854&scoped=true&"
import script from "./index--form.vue?vue&type=script&lang=js&"
export * from "./index--form.vue?vue&type=script&lang=js&"
import style0 from "./index--form.vue?vue&type=style&index=0&id=33043854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33043854",
  null
  
)

export default component.exports